import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c742d486"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "window"
};
var _hoisted_2 = {
  class: "flex"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "返回", -1);
});

var _hoisted_4 = {
  class: "content_box"
};
var _hoisted_5 = {
  class: "content-top"
};
var _hoisted_6 = {
  key: 1
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  style: {
    "margin-top": "20px",
    "display": "flex",
    "justify-content": "space-between"
  }
};
var _hoisted_9 = {
  style: {
    "margin-top": "20px"
  }
};
var _hoisted_10 = {
  class: "pagone"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "pagone"
  }, " 学分:2 ", -1);
});

var _hoisted_12 = {
  class: "pagone",
  style: {
    "width": "250px"
  }
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "学习进度", -1);
});

var _hoisted_14 = {
  style: {
    "display": "inline-block",
    "width": "150px",
    "margin-left": "10px"
  }
};
var _hoisted_15 = {
  style: {
    "margin-top": "30px"
  }
};
var _hoisted_16 = ["innerHTML"];
var _hoisted_17 = {
  class: "attachment"
};
var _hoisted_18 = {
  style: {
    "margin-top": "10px"
  }
};
var _hoisted_19 = {
  key: 0,
  class: "time"
};

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "倒计时", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ArrowRight = _resolveComponent("ArrowRight");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_Head = _resolveComponent("Head");

  var _component_myVideo = _resolveComponent("myVideo");

  var _component_el_progress = _resolveComponent("el-progress");

  var _component_DownFileList = _resolveComponent("DownFileList");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Head, {
    title: "在线学习",
    back: false
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", {
        class: "back",
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.backTwo && _ctx.backTwo.apply(_ctx, arguments);
        })
      }, [_hoisted_3, _createVNode(_component_el_icon, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_ArrowRight, {
            color: "#c62423"
          })];
        }),
        _: 1
      })])];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_ctx.videos ? (_openBlock(), _createBlock(_component_myVideo, {
    key: 0,
    ref: "videoRef",
    "read-time": _ctx.data.initReadTime,
    videourl: _ctx.videos,
    "set-time": _ctx.data.startTime,
    "is-readyvideo": _ctx.data.isReadyvideo,
    onPause: _ctx.handleVideo
  }, null, 8, ["read-time", "videourl", "set-time", "is-readyvideo", "onPause"])) : _createCommentVNode("", true), _ctx.data.detail.imgurl ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
    src: _ctx.baseUrl + _ctx.data.detail.imgurl,
    alt: ""
  }, null, 8, _hoisted_7)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.data.detail.title), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.data.detail.updateTime), 1), _hoisted_11, _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_progress, {
    percentage: _ctx.percent()
  }, null, 8, ["percentage"])])])])]), _createElementVNode("div", {
    class: _normalizeClass(_ctx.data.collect == true ? 'collect' : 'collect collect1'),
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    function () {
      return _ctx.handleCollect && _ctx.handleCollect.apply(_ctx, arguments);
    })
  }, _toDisplayString(_ctx.data.collect == true ? '已收藏' : '收藏'), 3)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    innerHTML: _ctx.data.detail.content
  }, null, 8, _hoisted_16)])]), _createElementVNode("div", _hoisted_17, [_withDirectives(_createVNode(_component_DownFileList, {
    ref: "downFileList",
    callback: true,
    onPickTiem: _ctx.test2,
    onDow: _ctx.handleDow
  }, null, 8, ["onPickTiem", "onDow"]), [[_vShow, _ctx.data.detail.attachmentId]]), _withDirectives(_createElementVNode("div", _hoisted_18, " 未上传附件 ", 512), [[_vShow, !_ctx.data.detail.attachmentId]])]), _ctx.data.detail.videoUrl == '' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_hoisted_20, _createElementVNode("p", {
    class: "times",
    style: _normalizeStyle({
      color: _ctx.data.detail.studyTime != 0 ? '#ffa201' : '#12d4c4'
    })
  }, _toDisplayString(_ctx.data.detail.studyTime != 0 ? _ctx.secTotime(_ctx.data.number) : "已完成"), 5)])) : _createCommentVNode("", true)]);
}